import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const GenderByRole: React.FC = () => {
  const { locale } = useRouter();

  const dataEN = [
    {
      role: 'Backend Developer',
      Women: 7.7304964539007095,
      Men: 92.05673758865248
    },
    {
      role: 'Full-stack Developer',
      Women: 9.695901278096079,
      Men: 89.95152049360952
    },
    {
      role: 'Frontend Developer',
      Women: 15.035460992907801,
      Men: 84.53900709219859
    },
    {
      role: 'Mobile Developer',
      Women: 8.899297423887589,
      Men: 90.39812646370024
    },
    {
      role: 'Software Architect',
      Women: 5.150976909413854,
      Men: 94.31616341030195
    },
    {
      role: 'DevOps, Infrastructure & SRE',
      Women: 4.651162790697675,
      Men: 95.01661129568106
    },
    {
      role: 'SysAdmin',
      Women: 6.666666666666667,
      Men: 93.33333333333333
    },
    {
      role: 'Design',
      Women: 48.19277108433735,
      Men: 51.80722891566265
    },
    {
      role: 'Product Manager',
      Women: 23.157894736842106,
      Men: 76.57894736842105
    },
    {
      role: 'Data Analysis & BI',
      Women: 15.112540192926044,
      Men: 84.56591639871382
    },
    {
      role: 'QA & Testing Engineer',
      Women: 19.45945945945946,
      Men: 80
    },
    {
      role: 'Project & Delivery Manager',
      Women: 19.507575757575758,
      Men: 80.49242424242425
    },
    {
      role: 'Data Scientist',
      Women: 13.432835820895523,
      Men: 86.56716417910447
    },
    {
      role: 'Data Engineer',
      Women: 6.870229007633588,
      Men: 92.87531806615776
    },
    {
      role: 'Engineering Manager',
      Women: 8.390022675736962,
      Men: 90.9297052154195
    },
    {
      role: 'Tech Lead',
      Women: 4.545454545454546,
      Men: 95.05347593582889
    }
  ].sort((a, b) => (a.Women > b.Women ? -1 : 1));

  const dataES = [
    {
      role: 'Backend Developer',
      Mujeres: 7.7304964539007095,
      Hombres: 92.05673758865248
    },
    {
      role: 'Full-stack Developer',
      Mujeres: 9.695901278096079,
      Hombres: 89.95152049360952
    },
    {
      role: 'Frontend Developer',
      Mujeres: 15.035460992907801,
      Hombres: 84.53900709219859
    },
    {
      role: 'Mobile Developer',
      Mujeres: 8.899297423887589,
      Hombres: 90.39812646370024
    },
    {
      role: 'Software Architect',
      Mujeres: 5.150976909413854,
      Hombres: 94.31616341030195
    },
    {
      role: 'DevOps, Infrastructure & SRE',
      Mujeres: 4.651162790697675,
      Hombres: 95.01661129568106
    },
    {
      role: 'SysAdmin',
      Mujeres: 6.666666666666667,
      Hombres: 93.33333333333333
    },
    {
      role: 'Design',
      Mujeres: 48.19277108433735,
      Hombres: 51.80722891566265
    },
    {
      role: 'Product Manager',
      Mujeres: 23.157894736842106,
      Hombres: 76.57894736842105
    },
    {
      role: 'Data Analysis & BI',
      Mujeres: 15.112540192926044,
      Hombres: 84.56591639871382
    },
    {
      role: 'QA & Testing Engineer',
      Mujeres: 19.45945945945946,
      Hombres: 80
    },
    {
      role: 'Project & Delivery Manager',
      Mujeres: 19.507575757575758,
      Hombres: 80.49242424242425
    },
    {
      role: 'Data Scientist',
      Mujeres: 13.432835820895523,
      Hombres: 86.56716417910447
    },
    {
      role: 'Data Engineer',
      Mujeres: 6.870229007633588,
      Hombres: 92.87531806615776
    },
    {
      role: 'Engineering Manager',
      Mujeres: 8.390022675736962,
      Hombres: 90.9297052154195
    },
    {
      role: 'Tech Lead',
      Mujeres: 4.545454545454546,
      Hombres: 95.05347593582889
    }
  ].sort((a, b) => (a.Mujeres > b.Mujeres ? -1 : 1));

  const data = locale === 'es' ? dataES : dataEN;
  const womenKey = locale === 'es' ? 'Mujeres' : 'Women';
  const menKey = locale === 'es' ? 'Hombres' : 'Men';

  return (
    <div>
      <StyledRecharts className="gender gender-by-role">
        <ResponsiveContainer height={550}>
          <BarChart data={data} layout="vertical">
            <XAxis type="number" hide={true}></XAxis>
            <YAxis
              type="category"
              dataKey="role"
              tickLine={false}
              width={210}
              axisLine={false}
              tickMargin={10}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => value.toFixed(1) + '%'}
              wrapperClassName="tooltip-y"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey={womenKey}
              stackId="a"
              barSize={12}
              radius={[5, 0, 0, 5]}
              fill="#746FB3"
            ></Bar>
            <Bar
              dataKey={menKey}
              stackId="a"
              barSize={12}
              radius={[0, 5, 5, 0]}
              fill="#1B9D76"
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default GenderByRole;
